// oxlint-disable-next-line no-restricted-imports
import { useId as useIdReact } from 'react';

/**
 * Wrapper for React's `useId` that forces a prefix and removes characters
 * that are not allowed in APIs like querySelector and CSS.
 *
 * https://github.com/facebook/react/issues/26839
 */
export function useId(prefix: string) {
	const reactId = useIdReact();
	return `${prefix}--${reactId.replaceAll(/[^\w-]/g, '')}`;
}
